// extracted by mini-css-extract-plugin
export default {"button":"_2HLQ6","hiddenLabel":"_1w76O"};